import { finalize } from 'rxjs/operators';
import {
  OnInit,
  Component,
  AfterContentInit,
  ElementRef,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ServiceLocator } from '../ServiceLocator';
import { I18nData } from '../api/plyca-dtos';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { WaitLoadingService } from './common/waitLoading/wait-loading.service';
import { HeaderActionsService } from './common/sub-header/header-actions.service';
import { generateRandomIdentifier } from '../ui.service';
import { FocusTrapFactory } from '@angular/cdk/a11y';
import { HelpService } from './common/help/help.service';
import { PlycaDataService } from '../../services/plyca.service';
import { Configuration } from '../conf/app.constants';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from './common/baseComponent/base.component';


export class MessageDTOModal {
  message: string;
  messageData: I18nData;
  titleKeyI18N: string;
  title: string;


  constructor(messageData: string | I18nData, titleKey?: string | I18nData) {

    if (messageData instanceof I18nData) {
      this.messageData = messageData;
    } else {
      this.message = messageData;
    }

    if (titleKey instanceof I18nData) {
      this.titleKeyI18N = titleKey.messageKey;
    } else if (titleKey) {
      this.title = titleKey;
    } else {
      this.titleKeyI18N = 'General.error';
    }
  }
}

@Component({
  selector: 'showcontent',
  templateUrl: 'showcontent.template.html'
})
export class showcontentComponent extends BaseComponent implements OnInit, AfterContentInit, AfterViewInit {
  @ViewChild('messageContainer', { static: false })
  messageContainer: ElementRef;
  public message: string;
  public title: string;
  windowHash: string;
  helpService: HelpService;
  loaded = false;
  printEnabled = false;

  constructor(
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private waitService: WaitLoadingService,
    private elem: ElementRef,
    private focusTrap: FocusTrapFactory,
    private headerActionsService: HeaderActionsService,
    public plycaService: PlycaDataService,
    protected configuration: Configuration
  ) {
    super();
    let translateService: TranslateService = ServiceLocator.injector.get(
      TranslateService
    );
    this.helpService = ServiceLocator.injector.get(HelpService);
    // MessageDTOModal
    if (dialogConfig['context'].messageData) {
      this.subscribe(
        translateService
          .get(
            dialogConfig['context'].messageData.messageKey,
            dialogConfig['context'].messageData.messageParams
          )
        , translation => (this.message = translation));
    } else {
      this.message = dialogConfig['context'].message;
    }

    if (dialogConfig['context'].title) {
      this.title = dialogConfig['context'].title;
    } else if (dialogConfig['context'].titleKeyI18N) {
      this.subscribe(
        translateService
          .get(dialogConfig['context'].titleKeyI18N)
        , translation => (this.title = translation));
    }


    if (dialogConfig['printEnabled']) {
      this.printEnabled = dialogConfig['printEnabled'];
    }
  }


  ngAfterContentInit(): void {
    this.waitService.startWaiting();

    this.windowHash = generateRandomIdentifier();




    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(

      this.headerActionsService.addWindowAction(
        'General.close',
        'fas fa-times',
        'btn-secondary',
        true, this.windowHash
      ), success => {
        this.ref.close();
      });







  }

  ngAfterViewInit(): void {
    this.messageContainer.nativeElement.innerHTML = this.message;

    // this.waitService.cancelWaiting();

    this.focusTrap.create(
      this.elem.nativeElement).focusFirstTabbableElementWhenReady()
      .then(focussed => {
        console.log('**** Foco en -> ' + document.activeElement)
      });
    this.subscribe(this.helpService.generateInternalLinksDialog(this.elem, this.ref)
      .pipe(finalize(() => this.loaded = true)));

  }

  ngOnInit(): void {
    console.log('ngOnInit');
  }



  afterLoadComplete(pdf: PDFDocumentProxy) {
    console.log('afterLoadComplete');
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public close() {
    console.log('cerrar');
    this.ref.close();
  }


  private getTagsHtml(tagName: keyof HTMLElementTagNameMap): string {
    const htmlStr: string[] = [];
    const elements = document.getElementsByTagName(tagName);
    for (let idx = 0; idx < elements.length; idx++) {
      htmlStr.push(elements[idx].outerHTML);
    }

    return htmlStr.join('\r\n');
  }
  print(): void {

    let printContents, popupWin;
    printContents = document.getElementById('sc-print-section').innerHTML;
    const stylesHtml = this.getTagsHtml('style');
    const linksHtml = this.getTagsHtml('link');
    popupWin = window.open('', '_print-window', 'top=0,left=0,height=80%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
    <html>
        <head>
          <title>TITULO</title>
          ${linksHtml}
          ${stylesHtml}
        </head>
    <body onload="window.print();window.close()">
      <div class="container-fluid  display-print">
      <div class="row">
      <div class="col-12">
      <div class="ui-editor-content ql-container ql-snow ql-disabled">${printContents}</div>
      </div>
      </div>
      </div>
    </body>
    </html>`);




    popupWin.document.close();
  }
}
